// ======================================================================
// File Name       : RoleDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE } from '../../constants/AuthorityConstant';
import { HYPHEN } from '../../constants';

class RoleDetail extends React.Component {
  /**
     * Get authority text by number
     * @param {number} authority
     * @return {string}
     */
  getAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '参照のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  getAuthorityDisplayText(authority) {
    switch (authority) {
      case 0:
        return '非表示';
      case 1:
      case 2:
        return '表示';
      default:
        return '';
    }
  }

  // Step 11.0.0 START
  getAdminMaskStatusDisplayText(authority) {
    switch (authority) {
      case 0:
        return '全て表示';
      case 1:
        return 'マニュアルのみ表示';
      case 2:
        return '非表示';
      default:
        return '';
    }
  }
  // Step 11.0.0 END

  /**
     * Life cycle function
     */
  shouldComponentUpdate(nextProps) {
    return nextProps.authority !== null;
  }

  /**
     * Render method of component
     */
  render() {
    const { isDetail } = this.props;
    const { superuserEnterpriseRoleName, superuserEnterpriseRoleSecernId, managementFunctionAuthorityInfo, managementFunctionAuthorityDisplayInfo } = this.props.authority;
    const leftColumn = isDetail ? 4 : 5;
    const rightColumn = isDetail ? 8 : 7;
    return (
      <Col sm={12}>
        <Form className='form-horizontal'>
          {superuserEnterpriseRoleSecernId && (
            <Row>
              <Form.Group>
                <Col sm={3} className="form-label">ロール識別ID</Col>
                <Col sm={9} className="padding-top-bottom-10">{superuserEnterpriseRoleSecernId}</Col>
              </Form.Group>
            </Row>
          )}
          <Row>
            <Form.Group>
              <Col sm={3} className="form-label">ロール名</Col>
              <Col sm={9} className="padding-top-bottom-10">{superuserEnterpriseRoleName}</Col>
            </Form.Group>
          </Row>
          <Form.Group>
            <Col sm={12} className="form-label"><p>画面表示</p></Col>
          </Form.Group>
          <Form.Group className="padding-left-50">
            <Form.Group>
              <Col sm={12} className="padding-left-50">
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">企業管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.enterpriseManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">サービス管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.serviceManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">管理ユーザー</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.superuserManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">ロールと権限</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.superuserRoleManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">企業システム利用実績</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.enterprisePerformanceManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">企業向けお知らせ一覧</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.enterpriseNoticeManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                {/* Step 11.0.0 START */}
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">問い合わせ・マニュアル表示</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAdminMaskStatusDisplayText(
                      managementFunctionAuthorityDisplayInfo.hiddenStatusSettingDisplay,
                    )}
                  </Col>
                </Form.Group>
                {/* Step 11.0.0 END */}
              </Col>
            </Form.Group>
          </Form.Group>
          <Form.Group>
            <Col sm={12} className="form-label"><p>権限設定</p></Col>
          </Form.Group>
          <Form.Group className="padding-left-50">
            <Form.Group>
              <Col sm={12} className="padding-left-50">
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">企業管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.enterpriseManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.enterpriseManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">サービス管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.serviceManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.serviceManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">管理ユーザー</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.superuserManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.superuserManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">ロールと権限</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.superuserRoleManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.superuserRoleManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">企業システム利用実績</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.enterprisePerformanceManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.enterprisePerformanceManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">企業向けお知らせ一覧</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.enterpriseNoticeManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.enterpriseNoticeManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>
      </Col>
    );
  }
}

export default RoleDetail;
